var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPurpleCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.06371 13C4.81274 13 4.56178 12.9038 4.361 12.7115L1.80116 10.2596C1.39961 9.875 1.39961 9.29808 1.80116 8.91346C2.2027 8.52885 2.80502 8.52885 3.20656 8.91346L5.06371 10.6923L12.7934 3.28846C13.195 2.90385 13.7973 2.90385 14.1988 3.28846C14.6004 3.67308 14.6004 4.25 14.1988 4.63462L5.76641 12.7115C5.56564 12.9038 5.31467 13 5.06371 13Z",
    fill: "#8927EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurpleCheck);
export default __webpack_public_path__ + "static/media/purple-check.3607ce946b7cab2eb677c3377bcd7b61.svg";
export { ForwardRef as ReactComponent };